import CloseIcon from '@mui/icons-material/Close';
import { Avatar, IconButton } from '@mui/material';
import React from 'react';

import Text from 'commons/Text';
import Colors from 'configs/Colors';

const AccessListSection = ({ accessListData, classes, t, onRemove, onScroll }) => {
  const hasData = accessListData?.pages?.[0]?.count > 0;

  return (
    <div className={classes.content}>
      <Text
        type="sm"
        fontWeightBold
        color={Colors.Grey10}
        className={classes.sectionTitle}
      >
        {t('people_with_access')}
      </Text>

      <div
        className={classes.accessListContainer}
        onScroll={onScroll}
      >
        {hasData ? (
          accessListData?.pages?.map((group, i) => (
            <React.Fragment key={i}>
              {group.results.map((person) => (
                <div
                  key={person.id}
                  className={classes.personRow}
                >
                  <div className={classes.personInfo}>
                    <Avatar
                      className={classes.avatar}
                      src={person.avatar}
                    />
                    <div className={classes.personText}>
                      <Text
                        type="sm"
                        fontWeightBold
                        color={Colors.Grey10}
                      >
                        {person.legal_name}
                      </Text>
                      <Text
                        type="xs"
                        color={Colors.Grey7}
                      >
                        {person.name}
                      </Text>
                    </div>
                  </div>

                  {onRemove && (
                    <IconButton
                      size="small"
                      className={classes.removeButton}
                      onClick={() => onRemove(person)}
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  )}
                </div>
              ))}
            </React.Fragment>
          ))
        ) : (
          <Text
            type="sm"
            color={Colors.Grey7}
          >
            {t('no_shared_users_yet')}
          </Text>
        )}
      </div>
    </div>
  );
};

export default AccessListSection;
